import { jsx as _jsx } from "react/jsx-runtime";
import { Banner, DataTable, Text } from '@dixa/lib-shared-habla';
import { banHistoryColumns, banHistorySubColumns } from './columns';
const bansLoading = _jsx(Text.Paragraph, { children: "Loading bans history..." });
const bansFailed = (_jsx(Banner, { variant: "fail", icon: null, description: _jsx(Text.Paragraph, { children: "An error occurred while loading bans history" }) }));
const bansEmpty = (_jsx(Banner, { variant: "info", icon: null, description: _jsx(Text.Paragraph, { children: "There are no previous bans on any channels" }) }));
export const UserBanHistory = ({ items, asyncStatus, hasNextPage, hasPreviousPage, nextPage, previousPage, }) => {
    if (asyncStatus === 'failed') {
        return bansFailed;
    }
    if (!items.length) {
        if (asyncStatus === 'loading') {
            return bansLoading;
        }
        return bansEmpty;
    }
    return (_jsx(DataTable, { data: items, columns: banHistoryColumns, subTableDataSelector: (data) => data.unbanned_at || data.unbanning_agent ? [data] : [], subTableColumns: banHistorySubColumns, paginationProps: {
            loading: asyncStatus === 'loading',
            previousButtonDisabled: !hasPreviousPage,
            nextButtonDisabled: !hasNextPage,
            previousButtonClick: previousPage,
            nextButtonClick: nextPage,
        } }));
};
